import * as Contract from '@tableau/api-internal-contract-js';
import * as Fonts from '@tableau/fonts-tableau-serialized';
import { AddInInstancePresModel } from '../ApiCore';
import { telemetryFunctionComplete } from '../telemetry/ExtensionsTelemetryDispatcher';
import { FunctionResults, telemetryFunctionStart } from '../telemetry/TelemetryDispatcher';

/**
 * This class is a wrapper for specialized handling of Font Loading commands.
 */
export class FontHandler {
  private fontsAlreadyFound: Set<string> = new Set<string>();

  public constructor(private _extensionInstance: AddInInstancePresModel) {}

  /**
   * If the passed command is one that is handled by this handler (i.e. related to Font
   * Loading), this will handle that command and return true.  Returns false otherwise.
   */
  public tryHandleCommand(msg: Contract.CommandMessage): Contract.ExecuteResponse | undefined {
    if (msg.verbId === Contract.VerbId.GetFonts) {
      return this.handleGetFontsCommand(msg);
    }

    return undefined;
  }

  private handleGetFontsCommand(msg: Contract.CommandMessage): Contract.ExecuteResponse {
    const fontNameAndInfos = new Array<Contract.FontNameAndInfo>();

    const fontNames = msg.parameters[Contract.ParameterId.FontNameListItems] as Array<string>;

    const runtimeData = telemetryFunctionStart();
    fontNames.forEach((fontName) => {
      const result = Fonts.FontInfoLookup.findFirstFontAndUpdateFontsFound(fontName, this.fontsAlreadyFound);
      if (result) {
        fontNameAndInfos.push({ fontName: result.fontName, fontBinaryInfo: result.fontBinaryInfo });
      }
    });

    telemetryFunctionComplete(msg.verbId, runtimeData, msg.parameters, FunctionResults.Success({}), this._extensionInstance);

    return { result: fontNameAndInfos };
  }
}
